<script setup></script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0002 7.55566V16.4446" stroke-linecap="round" />
    <path d="M7.55469 12.0002H16.4436" stroke-linecap="round" />
    <path
      d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z"
    />
  </svg>
</template>

<style scoped lang="scss"></style>
